import React, { useMemo, useRef, useEffect, useState } from "react";
// import { COLORS } from "../../../services/Constant";
import ModuleLight from "./moduleLight";
import SingleLight from "./singleLight";

const LightBarPreviewComponent = ({ lightData, closeLightbarPreviewModel, tooltipData }) => {
  let lightbar = tooltipData.replace(/<br \/>/gi, "<br>");
  lightbar = lightbar.replace(/<br\/>/gi, "<br>");
  lightbar = lightbar.split("<br>");

  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  // calculate bounds
  const { maxX, maxY } = useMemo(
    () => ({
      maxX: Math.max(...lightData.map((l) => +l.left + +l.width)),
      maxY: Math.max(...lightData.map((l) => +l.top + +l.height)),
    }),
    [lightData]
  );

  const sortedLightData = lightData
    .sort((a, b) => +a.lightheadPosition - +b.lightheadPosition)
    .filter((light) => light.angle !== "90" && light.angle !== "270");
  const topLightheads = sortedLightData.filter((lighthead) => lighthead.top === "0");

  // calculate scale to fit container
  useEffect(() => {
    const resize = () => {
      if (!containerRef.current) return;

      const { offsetWidth, offsetHeight } = containerRef.current;
      const scaleX = offsetWidth / maxX;
      const scaleY = offsetHeight / maxY;

      // maintain aspect ratio
      const newScale = Math.min(scaleX, scaleY) * 0.65;
      if (lightData.length <= 8 && newScale > 15) {
        setScale(15);
        return;
      }
      setScale(newScale);
    };

    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, [maxX, maxY]);

  const moduleOutputs =
    lightData.filter((light) => light.moduleOutputs && Array.isArray(light.moduleOutputs)).length > 0;

  return (
    <div id="previewLightbar-modal" className="m-auto mg-top-4">
      <div className="modal-dialog m-0">
        <div className="modal-content">
          <div className="close-icon text-right">
            <button type="button" className="close" onClick={closeLightbarPreviewModel}>
              <i className="fa fa-times text-red" />
            </button>
          </div>

          <h2 className="modal-title text-white text-uppercase">PREVIEW</h2>
          <div className="fixed-box">
            <></>
          </div>
          {/* Container */}
          <div
            className="canvas-position"
            ref={containerRef}
            style={{
              width: "100%",
              minHeight: "100px", // allow it to grow if needed
              padding: "20px 0", // spacing inside
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            {/* Scaled Canvas, In case of Freedom V data needs recalculation */}
            <div
              style={{
                position: "relative",
                width: maxX * scale - (moduleOutputs ? 40 : 0),
                height: maxY * scale + (moduleOutputs ? 20 : 0),
                margin: "0 auto",
                display: "flex",
              }}
            >
              {lightData.map((light) =>
                light.moduleOutputs ? (
                  <ModuleLight
                    key={light.outputId}
                    light={light}
                    lightData={lightData}
                    topLightheads={topLightheads}
                    scale={scale}
                  />
                ) : (
                  <SingleLight key={light.outputId} light={light} scale={scale} />
                )
              )}
            </div>
            <div style={{ position: "relative", top: "20px" }}>
              {lightbar.map((data) => (
                <div className="text-white mt-10">{data}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LightBarPreviewComponent;
